import {
  CREATE_EVENT_ERROR,
  CREATE_EVENT_SUCCESS,
  DELETE_EVENT_ERROR,
  DELETE_EVENT_SUCCESS,
  FETCH_EVENTS_ERROR,
  FETCH_EVENTS_SUCCESS,
  UPDATE_EVENT_ERROR,
  UPDATE_EVENT_SUCCESS
} from './types';

const initialState = {
  loading: false,
  data: [],
  error: "",
};

export default function eventReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: "",
      };
    case FETCH_EVENTS_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload,
      };
    case CREATE_EVENT_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        loading: false,
        error: "",
      };
    case CREATE_EVENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        data: state.data.map((event) =>
          event._id === action.payload._id ? action.payload : event
        ),
        loading: false,
        error: "",
      };
    case UPDATE_EVENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.filter((event) => event._id !== action.payload),
        error: "",
      };
    case DELETE_EVENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
